import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    token: "USDC",
    network: "ERC20",
    address: "",
    amount: "",
    naration: "",
    invoice: null,
    supportDocument: null,
};

const cryptoTransferSlice = createSlice({
    name: "cryptoTransfer",
    initialState,
    reducers: {
        setCryptoToken: (state, action) => {
            state.token = action.payload;
        },
        setCryptoNetwork: (state, action) => {
            state.network = action.payload;
        },
        setCryptoAddress: (state, action) => {
            state.address = action.payload;
        },
        setCryptoAmount: (state, action) => {
            state.amount = action.payload;
        },
        setCryptoNaration: (state, action) => {
            state.naration = action.payload;
        },
        setCryptoInvoice: (state, action) => {
            state.invoice = action.payload;
        },
        setCryptoSupportDocument: (state, action) => {
            state.supportDocument = action.payload;
        },

        patchCryptoTransfer: (state, action) => {
            Object.assign(state, action.payload || {});
        },

        resetCryptoTransfer: () => initialState,
    },
});

export const {
    setCryptoToken,
    setCryptoNetwork,
    setCryptoAddress,
    setCryptoAmount,
    setCryptoNaration,
    setCryptoInvoice,
    setCryptoSupportDocument,
    patchCryptoTransfer,
    resetCryptoTransfer,
} = cryptoTransferSlice.actions;

export default cryptoTransferSlice.reducer;

export const selectCryptoTransfer = (state) => state.cryptoTransfer;
export const selectCryptoPayload = (state) => {
    const { address, amount, naration, invoice, supportDocument } =
        state.cryptoTransfer || initialState;
    // what API expects
    return { address, amount, naration, invoice, supportDocument };
};
